import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { commentDisplayBody } from '../../utils/comment-display';

const CommentEntry = ({ entry, data, readOnly, deleting, onDelete, onEdit }) => {
  const t = data.t;
  const [menuAnchor, setMenuAnchor] = useState(null);
  const canDelete = !readOnly && !entry.deleted && entry.capabilities?.can_delete;
  const canEdit = !readOnly && !entry.deleted && entry.kind === 'user_comment' && entry.capabilities?.can_edit;
  const author = entry.kind === 'legacy_import' ? t.read('comment_ui.legacy_import')
    : entry.author?.display_name || t.read('comment_ui.unknown_author');
  const initials = author.split(/\s+/).slice(0, 2).map((part) => part[0]).join('');
  const systemAuthor = entry.kind === 'system_note' || entry.kind === 'legacy_import' || entry.author?.type === 'system';
  const date = entry.created_at ? new Date(entry.created_at) : null;
  const timestamp = date && !Number.isNaN(date.getTime())
    ? new Intl.DateTimeFormat(t.lang === 'fr' ? 'fr-CA' : 'en-CA', { dateStyle: 'medium', timeStyle: 'short' }).format(date)
    : t.read('comment_ui.unknown_date');
  return (
    <article className="comment-entry">
      <span className="comment-avatar" aria-hidden="true">{systemAuthor
        ? <img src={`${process.env.PUBLIC_URL || ''}/logo192.png`} alt="XPENS" /> : initials}</span>
      <div className="comment-content">
        <div className="comment-meta"><strong>{author}</strong><time dateTime={entry.created_at || undefined}>{timestamp}</time>
          {entry.updated_at && entry.kind === 'user_comment' && <small title={new Date(entry.updated_at).toLocaleString()}>{t.read('comment_ui.edited')}</small>}
          {entry.kind !== 'user_comment' && entry.kind !== 'legacy_import' && <span className="comment-kind">{t.read(`comment_ui.${entry.kind}`)}</span>}
        </div>
        <p className="comment-body">{entry.deleted ? t.read('comment_ui.deleted') : commentDisplayBody(entry)}</p>
        {entry.represented_user_id && <small>{t.read('comment_ui.on_behalf')}</small>}
        {(canDelete || canEdit) && <>
          <button type="button" className="comment-action btn btn-link btn-sm text-secondary" disabled={deleting}
            aria-label={t.read('comment_ui.actions')} title={t.read('comment_ui.actions')}
            aria-haspopup="menu" aria-expanded={Boolean(menuAnchor)} onClick={(event) => setMenuAnchor(event.currentTarget)}>
            <FontAwesomeIcon icon={faEllipsisH} />
          </button>
          {/* MUI handles keyboard navigation, outside clicks and focus restoration. */}
          <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
            {canEdit && <MenuItem disabled={deleting} onClick={() => { setMenuAnchor(null); onEdit(entry); }}>{t.read('comment_ui.edit')}</MenuItem>}
            {canDelete && <MenuItem disabled={deleting} onClick={() => { setMenuAnchor(null); onDelete(entry); }}>{t.read('delete')}</MenuItem>}
          </Menu>
        </>}
      </div>
    </article>
  );
};
export default CommentEntry;
